import React from 'react';

export function CalendarTodayIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M40 6h-2V2h-4v4H14V2h-4v4H8c-2.2 0-4 1.8-4 4v32c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4zm0 36H8V20h32v22zm0-26H8v-6h32v6z" />
    </svg>
  );
}
